import { graphql } from '@/generated/gql';

export const INTAKE_QUOTE_UPLOAD_STEP_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeQuoteUploadStepMutation($data: SvbrgQuoteAnalysisInput!) {
    sevenbridges {
      chatSession {
        quote {
          analyse(data: $data) {
            id
            fileId
          }
        }
      }
    }
  }
`);

export const INTAKE_QUOTE_UPLOAD_SKIP_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeQuoteUploadSkip($data: SvbrgChatSessionInput!) {
    sevenbridges {
      chatSession {
        quote {
          skip(data: $data)
        }
      }
    }
  }
`);
